module.exports = __webpack_public_path__ + "img/times.d5209bce.svg";